/**
 * Registers the slice's translations under the shared "reports" namespace,
 * merging over the placeholder `reports.title`/`placeholder` seeded in the
 * foundation locale JSON. Side-effect import from index.tsx (runs once).
 */
import i18n from "@/lib/i18n/i18n";

import { reportsEn } from "./locales/en";
import { reportsFr } from "./locales/fr";

i18n.addResourceBundle("fr", "translation", { reports: reportsFr }, true, true);
i18n.addResourceBundle("en", "translation", { reports: reportsEn }, true, true);
